import intialState from "../models/toasts";

export const types = {
  ADD_TOAST: "ADD_TOAST",
  CLOSE_TOAST: "CLOSE_TOAST",
  CLEAR_TOASTS: "CLEAR_TOASTS"
};

export const actions = {
  addToast: value => {
    return { type: types.ADD_TOAST, value };
  },
  closeToast: value => {
    return { type: types.CLOSE_TOAST, value };
  },
  clearToasts: () => {
    return { type: types.CLEAR_TOASTS };
  }
};

export default function reducer(state = intialState, action) {
  switch (action.type) {
    case types.ADD_TOAST:
      return {
        ...state,
        count: state.count + 1,
        toasts: [
          ...state.toasts,
          { ...action.value, id: state.count + 1, closed: false }
        ]
      };

    case types.CLOSE_TOAST:
      return {
        ...state,
        count: state.count - 1,
        toasts: state.toasts.map(t =>
          t.id === action.value ? { ...t, closed: true } : t
        )
        // toasts: state.toasts.filter(t => t.id !== action.value)
      };

    case types.CLEAR_TOASTS:
      return {
        ...state,
        toasts: []
      };

    default:
      return state;
  }
};
